import React from 'react';
import StaticPage from './StaticPage';

/**
 * TCH-02-FR-02 requires acceptance of the Terms of Service at registration.
 * The route exists so that acceptance is never requested against a 404; the
 * binding text is owned by the business and is not written here.
 */
const Terms: React.FC = () => (
  <StaticPage
    title="Términos del Servicio"
    intro="Las condiciones bajo las que puedes usar IQMaxx."
    pendingLegalCopy
  />
);

export default Terms;
